import * as PIXI from 'pixi.js';
import { ParentMixin } from '../core/parentMixin';
import { UpdateFlowMixin } from '../core/updateFlowMixin';
import { SerializableMixin } from '../core/serializableMixin';
import {
    AlphaAttribute,
    ColorAttribute,
    getAttributesToSerialize,
    NumberAttribute,
    StringAttribute,
} from '../core/attributes';
import { Config } from '../video-data/config';
import { GradientPoint } from '../core/GradientPoint';

export class DynamicCircleConfigurator extends UpdateFlowMixin(
    ParentMixin(SerializableMixin(PIXI.utils.EventEmitter)),
) {
    override _name = 'dynamicCircleConfigurator';
    override _classType = 'DynamicCircleConfigurator';
    readonly graphicType = Config.CIRCLE_GRAPHIC;

    @ColorAttribute()
    private accessor fillColor = 0xff00ff;
    @AlphaAttribute()
    private accessor fillAlpha = 0.5;
    @ColorAttribute()
    private accessor strokeColor = 0xff00ff;
    @AlphaAttribute()
    private accessor strokeAlpha = 0.5;
    @NumberAttribute({ min: 0, animatable: false })
    private accessor strokeWidth = 0;
    @NumberAttribute({ min: 0 })
    private accessor radius = 10;
    @NumberAttribute({ animatable: false })
    private accessor positionX = 0;
    @NumberAttribute({ animatable: false })
    private accessor positionY = 0;
    @StringAttribute({ choices: ['solid', 'linear'], animatable: false })
    private accessor fillType: 'solid' | 'linear' = 'solid';

    gradientStartPoint = new GradientPoint({ parent: this, x: 0, y: 0.5, color: 0xff0000 });
    gradientEndPoint = new GradientPoint({ parent: this, x: 1, y: 0.5, color: 0x0000ff });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-useless-constructor
    constructor(settings: any) {
        super(settings);
    }

    override get readonlyProperties(): string[] {
        return [];
    }

    override get propertiesToSerialize() {
        return getAttributesToSerialize(this).concat(['gradientStartPoint', 'gradientEndPoint']);
    }

    override get editableProperties() {
        return super.editableProperties.concat([
            'fillColor',
            'fillAlpha',
            'strokeColor',
            'strokeAlpha',
            'fillType',
            'gradientStartPoint',
            'gradientEndPoint',
        ]);
    }
}
